/* REDSALT three-bag Loop bundle: one-time first-order gifts.
 * Kept separate from Loop's generated bundle script so Loop updates are safe.
 */
(function () {
  'use strict';

  var TARGET_BUNDLE_PATH = '/a/loop_subscriptions/bundle/9e35972edab3407c857e9f449b8572f5';
  var GIFT_MARKER_KEY = 'redsalt_three_bag_bundle_gifts_pending';
  var GIFT_VARIANT_IDS = [51019114676541, 51036378595645, 51756167463229];
  var GIFT_PROPERTY = '_redsalt_bundle_gift';
  var TRANSACTION_PROPERTY = '_redsalt_bundle_transaction';
  var MEMBERSHIP_TRANSACTION_PROPERTY = '_redsalt_membership_transaction';
  var PRESET_MEMBERSHIP_PROPERTY = '_redsalt_three_bag_membership';
  var ONE_BAG_MEMBERSHIP_PROPERTY = '_redsalt_one_bag_membership';
  var PRESET_TRANSACTION = 'preset-three-bag';

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function isTargetBundlePage() {
    return window.location.pathname === TARGET_BUNDLE_PATH;
  }

  function isBundleEditPage() {
    return window.location.pathname.indexOf('/a/loop_subscriptions/bundle/change/') !== -1;
  }

  async function getCart() {
    var response = await fetch(routesRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  function bundleTransactionId(item) {
    var properties = item && item.properties ? item.properties : {};
    return properties[MEMBERSHIP_TRANSACTION_PROPERTY] || properties._bundleId || properties.bundleId || '';
  }

  function pendingGiftRequest() {
    var raw = sessionStorage.getItem(GIFT_MARKER_KEY);
    if (!raw) return null;
    if (raw === 'true') return { source: 'byob', variantId: 0 };
    try { return JSON.parse(raw); } catch (error) { return { source: 'byob', variantId: 0 }; }
  }

  function presetTransactionId(item) {
    return item && item.key ? 'preset:' + item.key : '';
  }

  async function addGifts(transactionId, variantIds) {
    var items = variantIds.map(function (variantId) {
      var properties = {};
      properties[GIFT_PROPERTY] = 'true';
      properties[TRANSACTION_PROPERTY] = transactionId;
      properties._pmd_gift = 'true';
      return { id: variantId, quantity: 1, properties: properties };
    });

    var response = await fetch(routesRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    });
    if (!response.ok) throw new Error('Unable to add bundle gifts');
  }

  async function removeOrphanedGifts(cart) {
    var liveTransactions = {};
    var hasPresetBundle = false;
    cart.items.forEach(function (item) {
      var properties = item.properties || {};
      if (properties[GIFT_PROPERTY] === 'true') return;
      var transactionId = bundleTransactionId(item);
      if (transactionId) {
        liveTransactions[transactionId] = true;
        hasPresetBundle = true;
      }
      if (properties[PRESET_MEMBERSHIP_PROPERTY] === 'true' ||
          item.product_title === '3-Bag Performance Supply') {
        hasPresetBundle = true;
      }
      if (properties[ONE_BAG_MEMBERSHIP_PROPERTY] === 'true') {
        liveTransactions[presetTransactionId(item)] = true;
      }
    });
    if (hasPresetBundle) liveTransactions[PRESET_TRANSACTION] = true;

    var updates = {};
    cart.items.forEach(function (item) {
      var properties = item.properties || {};
      if (properties[GIFT_PROPERTY] !== 'true') return;
      if (!liveTransactions[properties[TRANSACTION_PROPERTY]]) updates[item.key] = 0;
    });

    if (!Object.keys(updates).length) return false;
    var response = await fetch(routesRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    });
    if (!response.ok) throw new Error('Unable to remove orphaned bundle gifts');
    return true;
  }

  async function reconcileGiftQuantities(cart) {
    var hasThreeBagMembership = false;
    var hasOneBagMembership = false;

    cart.items.forEach(function (item) {
      var properties = item.properties || {};
      if (properties[GIFT_PROPERTY] === 'true') return;
      if (bundleTransactionId(item) ||
          properties[PRESET_MEMBERSHIP_PROPERTY] === 'true' ||
          item.product_title === '3-Bag Performance Supply') {
        hasThreeBagMembership = true;
      }
      if (properties[ONE_BAG_MEMBERSHIP_PROPERTY] === 'true') {
        hasOneBagMembership = true;
      }
    });

    var allowedGiftIds = [];
    if (hasThreeBagMembership) {
      allowedGiftIds = GIFT_VARIANT_IDS.slice();
    } else if (hasOneBagMembership) {
      allowedGiftIds = [51036378595645, 51756167463229];
    }

    var giftsByVariant = {};
    cart.items.forEach(function (item) {
      var properties = item.properties || {};
      if (properties[GIFT_PROPERTY] !== 'true') return;
      var variantId = Number(item.variant_id);
      if (!giftsByVariant[variantId]) giftsByVariant[variantId] = [];
      giftsByVariant[variantId].push(item);
    });

    var updates = {};
    Object.keys(giftsByVariant).forEach(function (variantIdKey) {
      var variantId = Number(variantIdKey);
      var giftLines = giftsByVariant[variantId];
      if (allowedGiftIds.indexOf(variantId) === -1) {
        giftLines.forEach(function (item) { updates[item.key] = 0; });
        return;
      }

      var keepLine = giftLines[0];
      if (hasThreeBagMembership) {
        var preferredLine = giftLines.find(function (item) {
          var properties = item.properties || {};
          return properties[TRANSACTION_PROPERTY] === PRESET_TRANSACTION;
        });
        if (preferredLine) keepLine = preferredLine;
      }

      if (keepLine.quantity !== 1) updates[keepLine.key] = 1;
      giftLines.forEach(function (item) {
        if (item.key !== keepLine.key) updates[item.key] = 0;
      });
    });

    if (!Object.keys(updates).length) return false;
    var response = await fetch(routesRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    });
    if (!response.ok) throw new Error('Unable to reconcile bundle gifts');
    return true;
  }

  async function syncGiftsOnCart() {
    if (window.location.pathname !== routesRoot() + 'cart' && window.location.pathname !== '/cart') return;

    var cart = await getCart();
    var removed = await removeOrphanedGifts(cart);
    if (removed) {
      window.location.reload();
      return;
    }

    var reconciled = await reconcileGiftQuantities(cart);
    if (reconciled) {
      window.location.reload();
      return;
    }

    var pending = pendingGiftRequest();
    if (!pending) return;

    var bundleLine;
    if (pending.source === 'monthly') {
      bundleLine = cart.items.find(function (item) {
        var properties = item.properties || {};
        return properties[ONE_BAG_MEMBERSHIP_PROPERTY] === 'true' &&
          (!pending.variantId || Number(item.variant_id) === Number(pending.variantId));
      });
    } else if (pending.source === 'preset') {
      bundleLine = cart.items.find(function (item) {
        var properties = item.properties || {};
        return properties[PRESET_MEMBERSHIP_PROPERTY] === 'true' &&
          (!pending.variantId || Number(item.variant_id) === Number(pending.variantId));
      });
    } else {
      bundleLine = cart.items.find(function (item) {
        return Boolean(bundleTransactionId(item));
      });
    }
    if (!bundleLine && pending.variantId) {
      bundleLine = cart.items.find(function (item) {
        return Number(item.variant_id) === Number(pending.variantId);
      });
    }
    if (!bundleLine) return;

    var transactionId = pending.transactionId || bundleTransactionId(bundleLine) ||
      (pending.source === 'preset' ? PRESET_TRANSACTION : presetTransactionId(bundleLine));
    var existingGiftIds = {};
    cart.items.forEach(function (item) {
      var properties = item.properties || {};
      if (properties[GIFT_PROPERTY] === 'true' && properties[TRANSACTION_PROPERTY] === transactionId) {
        existingGiftIds[Number(item.variant_id)] = true;
      }
    });

    var requestedGiftIds = pending.giftIds && Array.isArray(pending.giftIds)
      ? pending.giftIds.map(Number).filter(Boolean)
      : GIFT_VARIANT_IDS.slice();
    var missingGiftIds = requestedGiftIds.filter(function (variantId) {
      return !existingGiftIds[variantId];
    });

    sessionStorage.removeItem(GIFT_MARKER_KEY);
    if (!missingGiftIds.length) return;

    await addGifts(transactionId, missingGiftIds);
    window.location.reload();
  }

  if (isTargetBundlePage() || isBundleEditPage()) {
    document.addEventListener('click', function (event) {
      var control = event.target.closest('button, a, [role="button"]');
      if (!control) return;
      var label = (control.textContent || '').trim().toUpperCase();
      if (label.indexOf('ADD TO CART') !== -1 || label.indexOf('UPDATE CART') !== -1) {
        sessionStorage.setItem(GIFT_MARKER_KEY, 'true');
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncGiftsOnCart().catch(function (error) { console.error('[REDSALT bundle gifts]', error); });
    });
  } else {
    syncGiftsOnCart().catch(function (error) { console.error('[REDSALT bundle gifts]', error); });
  }
})();
